import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./Assets/css/Style.css"
import "./Assets/css/FontAwesome/Css/all.min.css"
import "./Assets/css/FontAwesome/Css/fontawesome.min.css"
import 'cropperjs/dist/cropper.min.css'
// Screen CSS imported globally (not only per-screen) so it lands in the single
// main.css and applies on every screen — screens share classes across each other,
// which only works if the CSS is global. JS is still code-split per screen (the
// big win); CSS is small enough to keep in one file and avoids missing-style bugs.
import "./Assets/css/Dashboard.css"
import "./Assets/css/UserProfileEdit.css"
import "./Assets/css/CampaignForm.css"
import "./Assets/css/CampaignDetails.css"
import AppRouter from './Router/Route';
import Toast from './Components/Toast';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { useLocation } from 'react-router-dom';
import storage from './Assets/js/Global';
import { useContext } from 'react';
import { GlobalContext } from './Context/GlobalContext';
import SessionLoader from './Components/SessionLoader';

const App = () => {
  const { isSessionRestoring } = useContext(GlobalContext);
  const location = useLocation();
  const authRoutes = [
    '/',
    '/login',
    '/login-v2',
    '/password',
    '/forgot-password',
    '/verify-otp',
    '/signup/wellness-interests',
    '/reset-password',
    '/biometric-required',
    '/delete-account',
    '/signup/account-details',
    '/signup/physical-profile',
    '/signup/lifestyle',
    '/signup/wellness-priorities',
    '/qr-scanner',
    '/bp-calibration',
    '/update-app',
    '/welcome-back'
  ];

  const hideFooter = [
    "/invite-create",
    "/invite-details",
    "/scan-logs",
    "/app-version"
  ]

  if (
    location.pathname !== "/history" &&
    location.pathname !== "/user-scan-details"
  ) {
    storage.remove("lastSelectedDate");
  }

  const hideHeaderFooter =
    authRoutes.includes(location.pathname) ||
    location.pathname.startsWith("/campaign/");

  const showFooter =
    !hideHeaderFooter && !hideFooter.includes(location.pathname);
  return (
    <>
      <Toast />
      {isSessionRestoring && <SessionLoader />}
      {!hideHeaderFooter && <Header />}
      <div
        className={`app-content-wrap ${showFooter ? '' : 'no-footer'}`}
        style={{ paddingBottom: showFooter ? '60px' : '0' }}
      >
        <AppRouter />
      </div>
      {showFooter && <Footer />}
    </>
  )
}

export default App;